export default "__VITE_ASSET__JJKRgBSW__"